import {navigationMobile, navigationHasChildren, navigationMobileClick} from "./parts/navigation.mobile";
import {selectDropDown} from "./parts/select-dropdown";
import {partnersClick} from "./parts/partners.click";
import {partnersSlider} from "./parts/partners.slider";
import {siteLoadMorePosts, siteMobileFilter } from "./parts/site.load-more-posts";
import {siteFilterChanges} from "./parts/site.filter-changes";
import {singleFag_ShowMore, singleFag_setHeightOfBlockQoute} from "./parts/single-fag";
import {formTilkendegivelse} from './parts/form.tilkendegivelse';
import {formTilmelding} from "./parts/form.tilmelding";
import {filterMenuMobile} from "./parts/filter-menu.mobile";
import {flexibleContent} from "./parts/flexible-content";
import {accordion} from "./parts/accordion";
import {favorite} from "./parts/favorite";
import {siteMain} from "./parts/site.main";
import { openModal, clickModal } from "./parts/modal";
import {userLogin, userLogout} from "./parts/user-login";
import {formOpretBruger} from "./parts/form.opret_bruger";


document.addEventListener('DOMContentLoaded', () => {
    navigationMobile();
    navigationHasChildren();
    navigationMobileClick();
    selectDropDown();
    partnersClick();
    partnersSlider();
    siteLoadMorePosts();
    siteMobileFilter();
    siteFilterChanges();
    singleFag_ShowMore();
    singleFag_setHeightOfBlockQoute();
    formTilkendegivelse();
    filterMenuMobile();
    flexibleContent();
    accordion();
    siteMain();
    openModal();
    clickModal();
    userLogin();
    userLogout();
    formOpretBruger();
})

formTilmelding();
favorite()
